import { parseActivityReturnContext } from "../../lib/activity-return-context.js";

const LIBRARY_CONTEXT_KEY = "learn-flow:library-return-context";

export function storeLibraryContext(path: string): void {
  const context = parseActivityReturnContext(path);
  if (context?.label === "Library") window.sessionStorage.setItem(LIBRARY_CONTEXT_KEY, path);
}

export function readStoredLibraryContext(): string {
  const stored = window.sessionStorage.getItem(LIBRARY_CONTEXT_KEY);
  const context = parseActivityReturnContext(stored);
  return context?.label === "Library" ? context.destination : "/library";
}
